import React, {createContext, useContext, useState, useMemo} from 'react'
import {ID} from '../../../../../_dashboard/helpers'

export interface ListViewContextProps {
  selected: ID[]
  onSelect: (id: ID) => void
  clearSelected: () => void
  isAllSelected: boolean
  onSelectAll: () => void
  itemIdForUpdate: ID | null
  setItemIdForUpdate: (id: ID | null) => void
  /** Read-only details modal */
  viewUserId: ID | null
  setViewUserId: (id: ID | null) => void
}

const ListViewContext = createContext<ListViewContextProps>({
  selected: [],
  onSelect: () => {},
  clearSelected: () => {},
  isAllSelected: false,
  onSelectAll: () => {},
  itemIdForUpdate: null,
  setItemIdForUpdate: () => {},
  viewUserId: null,
  setViewUserId: () => {},
})

export const ListViewProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [selected, setSelected] = useState<ID[]>([])
  const [itemIdForUpdate, setItemIdForUpdate] = useState<ID | null>(null)
  const [viewUserId, setViewUserId] = useState<ID | null>(null)

  const onSelect = (id: ID) => {
    setSelected((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id)
      }
      return [...prev, id]
    })
  }

  const clearSelected = () => {
    setSelected([])
  }

  const isAllSelected = useMemo(() => {
    return selected.length > 0
  }, [selected])

  const onSelectAll = () => {
    if (isAllSelected) {
      clearSelected()
    }
  }

  return (
    <ListViewContext.Provider
      value={{
      selected,
        onSelect,
        clearSelected,
        isAllSelected,
        onSelectAll,
        itemIdForUpdate,
        setItemIdForUpdate,
        viewUserId,
        setViewUserId,
      }}
    >
      {children}
    </ListViewContext.Provider>
  )
}

export const useListView = () => useContext(ListViewContext)
